import ReactSVGCore from 'react-svg';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

type MenuListProps = {
  open: boolean;
};

type ButtonType = {
  open: boolean;
};

type IconType = {
  color: string;
};

type ArrowIconType = {
  open: boolean;
};

export const Icon = lib.styled(ReactSVGCore)<IconType>`
    height: 16px;

    svg {
        width: 15px;
        height: 15px;
    }

    path {
        fill: ${(props: IconType) =>
          props.color !== null ? props.color : undefined};
    }
`;

export const ArrowIcon = lib.styled(ReactSVGCore)<IconType>`
  display: inline-block;
  color: ${colors.darkGray11};
  transition: transform 0.3s ease;
  transform: ${(props: ArrowIconType) =>
    props.open ? 'rotate(0deg)' : 'rotate(180deg)'};

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const Container = lib.styled.div`
    margin-left: -35px;
`;

export const Menu = lib.styled.ul`
    position: relative;
    display: inline-block;
`;

export const Button = lib.styled.button<ButtonType>`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 7px 10px 7px 10px;
    gap: 10px;
    background-color: ${(props: ButtonType) =>
      props.open ? colors.white : 'transparent'};
    color: ${colors.black};
    border: none;
    border-radius: 7px;
    cursor: pointer;
    font-family: 'Nunito';
    font-size: 14px;
    width: 150px;
    box-shadow: ${(props: ButtonType) =>
      props.open ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none'};
`;

export const MenuList = lib.styled.ul<MenuListProps>`
    display: ${(props: MenuListProps) =>
      props.open ? 'inline-block' : 'none'};
    position: absolute;
    top: 100%;
    left: 0;
    width: 140px;
    background-color: white;
    margin-top: 7px;
    list-style: none;
    z-index: 100;
    padding: 5px;
    border-radius: 7px;
    gap: 3px;

    opacity: ${(props: MenuListProps) => (props.open ? 1 : 0)};
    transition: opacity 0.5s ease, transform 0.5s ease;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

export const MenuItem = lib.styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 7px;
    font-size: 14px;
    font-family: Nunito;
    height: 25px;
    gap: 10px;
    padding: 5px;
    cursor: pointer;

    :hover {
        background-color: ${colors.lightGray};
    }
`;
